import React, { Component } from 'react';

import CustomScroll from 'react-custom-scroll';
import DayPicker from 'react-day-picker';
import Button from '@material-ui/core/Button';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Moment from 'moment';
import ModuleLoadingSpinner from '../../components/UI/ModuleLoadingSpinner';
import Hoc from '../../hoc/hoc';
import * as actions from '../../store/actions/index';
import classes from './TopList.css';

//const staticAvatar = 'https://firebasestorage.googleapis.com/v0/b/durex-quiz-11996.appspot.com/o/avatar-blank.png?alt=media&token=b8cbf1b2-53bb-4b62-a6e4-ce74cf6eb8c5';
const staticAvatar = './avatar-blank.png';

const MONTHS = [
	'Januar',
	'Februar',
	'Mart',
	'April',
	'Maj',
	'Jun',
	'Jul',
	'Avgust',
	'Septembar',
	'Oktobar',
	'Novembar',
	'Decembar',
  ];
  const WEEKDAYS_LONG = [
	'Nedelja',
	'Ponedeljak',
	'Utorak',
	'Sreda',
	'Četvrtak',
	'Petak',
	'Subota'
];

const WEEKDAYS_SHORT = ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'];



class TopList extends Component {

	state = {
		selectedDay: new Date(),
		currentList: null,
		currentListW: null,
		currentIndex: null,
		currentIndexW: null,
		stringDay: null,
		stringWeekStart: null,
		stringWeekEnd: null,
		hoverRange: undefined,
		selectedDays: [],
	}



	componentDidMount () {
		const day = new Date();
		const oct31 = new Date(1540983600000);
		if (day.getTime() > 1540983600000) {
			this.handleDayClick(oct31);
			this.handleDayChange(oct31);
		} else {
			this.handleDayClick(day);
			this.handleDayChange(day);
		}
	}

	componentWillReceiveProps (nextProps) {
		let sAnswer = null;
		if (nextProps.results !== this.props.results && nextProps.results!==undefined) {
			for (var n=10;n>0;n--) {
				if (nextProps.results[n]!==undefined && nextProps.results[n].length) {
					sAnswer=n;
					break;
				}
			}
			if (sAnswer!==null) {
				this.selectAnswersInstant(sAnswer,nextProps.results[n]);
			}
		}

		let sAnswerW = null;
		if (nextProps.weekResults !== this.props.weekResults && nextProps.weekResults!==undefined) {
			for (var m=10;m>0;m--) {
				if (nextProps.weekResults[m]!==undefined && nextProps.weekResults[m].length) {
					sAnswerW=m;
					break;
				}
			}
			if (sAnswerW!==null) {
				this.selectAnswersWInstant(sAnswerW,nextProps.weekResults[m]);
			}
		}
	}

	handleDayClick = (day, modifiers = {}) => {
		let dt;
		if (day.getTime() > 1540983600000) {
			dt = new Date(1540983600000);
		} else {
			dt = new Date(day);
		}
		
		//var timeOffset = dt.getTimezoneOffset();
		//console.log(timeOffset);
		var midnight = String(dt.getFullYear())+String(dt.getMonth()+1)+String(dt.getDate());
		var readableString = (String(dt.getDate()))+". "+MONTHS[(dt.getMonth())]+" "+String(dt.getFullYear())
		//console.log(midnight);
		if (modifiers.disabled) {
			return;
		}
		this.setState({
			selectedDay: modifiers.selected ? undefined : dt,
			stringDay: readableString,
			currentList: null,
			currentIndex: null
		});
		this.props.onStartGetResults(midnight);

	}


	// week datepicker

	handleDayChange = (date, modifiers = {} ) => {

		if (modifiers.disabled) {
			return;
		}
		//console.log(this.getWeekRange(date).from);
		this.setState({
		  selectedDays: this.getWeekDays(this.getWeekRange(date).from),
		});
	};
	
	handleDayEnter = date => {
		//console.log((date));
		this.setState({
		  hoverRange: this.getWeekRange(date),
		});
	};
	
	handleDayLeave = () => {
		this.setState({
			hoverRange: undefined,
		});
	};
	
	handleWeekClick = (weekNumber, days, e) => {
		this.setState({
		  selectedDays: days,
		});
	};

	selectAnswersInstant = (ind,arr) => {
		//console.log(ind);
		this.setState({
			currentList: arr,
			currentIndex: ind
		})
	}

	selectAnswers = (ind) => {
		this.setState({
			currentList: this.props.results[ind],
			currentIndex: ind
		})
	}

	selectAnswersW = (ind) => {
		this.setState({
			currentListW: this.props.weekResults[ind],
			currentIndexW: ind
		})
	}

	selectAnswersWInstant = (ind,arr) => {
		this.setState({
			currentListW: arr,
			currentIndexW: ind
		})
	}


	getWeekDays = (weekStart) => {

		var dt = new Date(weekStart);
		
		var weekStartMidnight = String(dt.getFullYear())+String(dt.getMonth()+1)+String(dt.getDate());
		var readableString = (String(dt.getDate()))+". "+MONTHS[(dt.getMonth())];

		var dt2 = Moment(weekStart).add(6, 'days').toDate();
		//var weekEndMidnight = String(dt2.getFullYear())+String(dt2.getMonth()+1)+String(dt2.getDate());
		var readableString2 = (String(dt2.getDate()))+". "+MONTHS[(dt2.getMonth())]+" "+String(dt2.getFullYear())

		//console.log(readableString, readableString2);

		this.setState({
			stringWeekStart: readableString,
			stringWeekEnd: readableString2,
			currentListW: null,
			currentIndexW: null
		});
		this.props.onStartGetResultsWeek(weekStartMidnight);


		const days = [weekStart];
		for (let i = 1; i < 7; i += 1) {
		  days.push(
			Moment(weekStart)
			  .add(i, 'days')
			  .toDate()
		  );
		}
		return days;
	}
	  
	getWeekRange = (date) => {
		if (date.getDay()===6) {
			return {
				from: Moment(date)
					.startOf('week').day(6)
					.toDate(),
				to: Moment(date)
					.endOf('week').day(12)
					.toDate(),
				};
		} else {
			return {
				from: Moment(date)
					.startOf('week').day(-1)
					.toDate(),
				to: Moment(date)
					.endOf('week').day(5)
					.toDate(),
				};
		}

	}

	sortByResult (a, b) {
		var x = parseInt(a['finalscore'],10);
		var y = parseInt(b['finalscore'],10);
		return x - y;
	};


	render () {

		let dailyWinnerList = "";
		let helperSortedArray = [];
		if (this.props.loading) {
			dailyWinnerList = <ModuleLoadingSpinner/>;
		} else {
			if (this.state.currentList) {
				helperSortedArray = Array.from(this.state.currentList);
				helperSortedArray.sort(this.sortByResult);
				dailyWinnerList = helperSortedArray.map(el => {
					return (
					<div className={classes.winner} key={el['ts']}>
						<img src={el['avatar'] ? el['avatar'] : staticAvatar } alt="Avatar"/>
						<div className={classes.flexColumn}>
							<span style={{'textTransform':'capitalize'}}>{(el['ime']).toLowerCase()}</span>
							<span style={{color:'#f3ff9a',fontWeight:'bold',fontSize:'17px'}}><strong>Rezultat: </strong>{Moment(parseInt(el['finalscore'],10)).format("mm:ss.SSS")}</span>
							<span style={{fontSize:'14px'}}><strong>Vreme igranja: </strong>{Moment(parseInt(el['ts'],10)).format("HH:mm")}</span>
						</div>
					</div>
					);
				})
			} else {
				dailyWinnerList = <div className={classes.topListSubHeaderHighlight}>Nema rezultata u ovom periodu.</div>
			}
		}

		let weeklyWinnerList = "";
		let helperWeeklySortedArray = [];
		if (this.props.loadingW) {
			weeklyWinnerList = <ModuleLoadingSpinner/>;
		} else {
			if (this.state.currentListW) {
				helperWeeklySortedArray = Array.from(this.state.currentListW);
				helperWeeklySortedArray.sort(this.sortByResult);
				weeklyWinnerList = helperWeeklySortedArray.map(el => {
					if (el['ts'] > 1541030399000) {
						return (null);
					} else {
					return (
					<div className={classes.winner} key={el['ts']+el['finalscore']}>
						<img src={el['avatar'] ? el['avatar'] : staticAvatar } alt="Avatar"/>
						<div className={classes.flexColumn}>
							<span style={{'textTransform':'capitalize'}}>{(el['ime']).toLowerCase()}</span>
							<span style={{color:'#f3ff9a',fontWeight:'bold',fontSize:'17px'}}><strong>Rezultat: </strong>{Moment(parseInt(el['finalscore'],10)).format("mm:ss.SSS")}</span>
							<span style={{fontSize:'14px'}}><strong>Vreme igranja: </strong>{Moment(parseInt(el['ts'],10)).format("DD.MM.YY HH:mm")}</span>
						</div>
					</div>
					);
					}
				})
			} else {
				weeklyWinnerList = <div className={classes.topListSubHeaderHighlight}>Nema rezultata u ovom periodu.</div>
			}

		}

		let butArr=[];
		let butArr2=[];
		for (var k=1;k<=10;k++) {
			let disabledCheck = true;
			let disabledCheckWeek = true;
			if (this.props.results) {
				if (this.props.results[k]!==undefined && this.props.results[k].length!==0) {
					//console.log(k, this.props.results[k])
					disabledCheck = false;
				}
			}

			if (this.props.weekResults) {
				if (this.props.weekResults[k]!==undefined && this.props.weekResults[k].length!==0) {
					//console.log(k, this.props.weekResults[k])
					disabledCheckWeek = false;
				}
			}
			let col = "primary";
			let colW = "primary";
			if (this.state.currentIndex===k) {
				col = "secondary";
			}
			if (this.state.currentIndexW===k) {
				colW = "secondary";
			}
			butArr.unshift(
				<Button
				variant="contained" size="small"
				onClick={this.selectAnswers.bind(this, k)}
				key={k}
				color={col}
				disabled={disabledCheck}
				>{k}</Button>
			)
			butArr2.unshift(
				<Button
				variant="contained" size="small"
				onClick={this.selectAnswersW.bind(this, k)}
				key={100+k}
				color={colW}
				disabled={disabledCheckWeek}
				>{k}</Button>
			)

		}

		
		const daytitle = this.state.stringDay ? (<div className={classes.topListSubHeader}><span>Rezultati za dan <span className={classes.topListSubHeaderHighlight}>{this.state.stringDay}</span></span></div>) : null;

		let numbertitle = null;

		if (this.state.currentIndex) {
			let str=' tačna odgovora';
			if (this.state.currentIndex>=5) {
				str = ' tačnih odgovora';
			} else if (this.state.currentIndex===1) {
				str= ' tačan odvovor';
			}
			numbertitle = (<div className={classes.topListNumberHeader}><span className={classes.curIndexNumber}>{this.state.currentIndex}</span>{str}</div>);
			
		}

		// week stuff

		

		const daysAreSelected = this.state.selectedDays.length > 0;

		const weektitle = this.state.stringWeekStart ? (<div className={classes.topListSubHeader}><span>Rezultati za period <span className={classes.topListSubHeaderHighlight}>{this.state.stringWeekStart} - {this.state.stringWeekEnd}</span></span></div>) : null;

		let numbertitleW = null;

		if (this.state.currentIndexW) {
			let strW =' tačna odgovora';
			if (this.state.currentIndexW>=5) {
				strW = ' tačnih odgovora';
			} else if (this.state.currentIndexW===1) {
				strW = ' tačan odvovor';
			}
			numbertitleW = (<div className={classes.topListNumberHeader}><span className={classes.curIndexNumber}>{this.state.currentIndexW}</span>{strW}</div>);
		}
		

		const modifiers = {
		  hoverRange: this.state.hoverRange,
		  selectedRange: daysAreSelected && {
			from: this.state.selectedDays[0],
			to: this.state.selectedDays[6],
		  },
		  hoverRangeStart: this.state.hoverRange && this.state.hoverRange.from,
		  hoverRangeEnd: this.state.hoverRange && this.state.hoverRange.to,
		  selectedRangeStart: daysAreSelected && this.state.selectedDays[0],
		  selectedRangeEnd: daysAreSelected && this.state.selectedDays[6]
		}

		let endDaysDate = new Date(2018, 9, 31);
		const nowTs = new Date().getTime();
		const endTs = new Date(2018,10,1).getTime();
		
		if (nowTs < endTs) {
			endDaysDate = new Date();
		} else {
			endDaysDate = new Date(2018, 9, 31);
		}

		let endWeeksDate = new Date(2018,9,26);
		const weekEndTs = new Date(2018,9,27).getTime();
		if (nowTs < weekEndTs) {
			endWeeksDate = new Date();
		}

		return (
			<Hoc>
				<div style={{width:'100%',textAlign:'center'}} >
					<h1 className={classes.h1Custom}>Top lista</h1>
				</div>
				<div style={{width:'100%',textAlign:'center'}} >
					<h2 className={classes.h2Custom}>Dnevna</h2>
				</div>
				<div className={classes.topListHolder}>
					<div className={classes.topListDayPicker}>
					<p>Izaberite dan:</p>
						{<DayPicker 
							className={classes.DayPicker}
							onDayClick={this.handleDayClick}
							locale="sr"
							months={MONTHS}
							weekdaysLong={WEEKDAYS_LONG}
							weekdaysShort={WEEKDAYS_SHORT}
							firstDayOfWeek={1}
							selectedDays={new Date(2018,9,31)}
							showOutsideDays={false} 
							month={new Date(2018,9,31)}
							fromMonth={new Date(2018, 8)}
							toMonth={new Date(2018, 9)}
							disabledDays={[
								{
								  after: endDaysDate,
								  before: new Date(2018, 8, 15),
								},
							  ]}
						/>}
						<p>Izaberite broj tačnih odgovora:</p>
						<div className={classes.numberList}>
							{butArr.map(el=>{return el})}
						</div>
					</div>
					<div className={classes.topListSide}>
						<div className={classes.winnerList}>
						

						{daytitle}

						<CustomScroll flex="1">
							<div className={classes.winnerListScrollable}>

								{numbertitle}
								{dailyWinnerList}
							</div>
						</CustomScroll>
						</div>
					</div>
				</div>







				<div style={{width:'100%',textAlign:'center'}} >
					<h2 className={classes.h2Custom}>Nedeljna</h2>
				</div>

				<div className={classes.topListHolder}>
					<div className={classes.topListSide}>
						<div className={classes.winnerList}>
							{weektitle}
							<CustomScroll flex="1">
								<div className={classes.winnerListScrollable}>
									{numbertitleW}
									{weeklyWinnerList}
								</div>
							</CustomScroll>
						</div>
					</div>
					<div className={classes.topListDayPicker}>
						<p>Izaberite nedelju:</p>
						<div className={"SelectedWeekExample"}>
						<DayPicker 
							className={classes.DayPicker}
							locale="sr"
							months={MONTHS}
							weekdaysLong={WEEKDAYS_LONG}
							weekdaysShort={WEEKDAYS_SHORT}
							firstDayOfWeek={1}
							month={new Date()}
							fromMonth={new Date(2018, 8)}
							toMonth={new Date(2018, 10)}
							
							disabledDays={[
								{
									after: endWeeksDate,
									before: new Date(2018, 8, 15),
								}
							]}
							
							selectedDays={this.state.selectedDays}
							showOutsideDays={true}
							modifiers={modifiers}
							onDayClick={this.handleDayChange}
							onDayMouseEnter={this.handleDayEnter}
							onDayMouseLeave={this.handleDayLeave}
							onWeekClick={this.handleWeekClick}
						/>
						<p>Izaberite broj tačnih odgovora:</p>
						<div className={classes.numberList}>
							{butArr2.map(el=>{return el})}
						</div>
						</div>
					</div>
				</div>
			</Hoc>
		);
	}
};

const mapStateToProps = state => {
	return {
		loading: state.res.loading,
		loadingW: state.res.loadingW,
		results: state.res.results,
		weekResults: state.res.weekResults
	};
}

const mapDispatchToProps = dispatch => {
	return {
		onStartGetResults: (day) => dispatch(actions.getResultsByDay(day) ),
		onStartGetResultsWeek: (day) => dispatch(actions.getResultsByWeek(day) ),
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopList));


// WEBPACK FOOTER //
// ./src/containers/TopList/TopList.js